import React from 'react'
import {logoLink} from './styles/Logo'
import {styled} from 'stitches/config'

const NINCHAT_URL = 'https://ninchat.com'

const StyledLogoLink = styled('a', logoLink)

export const LogoView = () => (
    <StyledLogoLink
        href={`${NINCHAT_URL}`}
        rel='noopener noreferrer'
        target='_blank'
        title='Ninchat'
    >
        <i className='ni ni-ninchat-logo LogoIcon' />
        <br />
        <i className='ni ni-ninchat-text LogoText' />
    </StyledLogoLink>
)

export default LogoView
